module.exports = __webpack_public_path__ + "img/IDefaultPageHome.4e7a2139.png";